import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  Box
} from '@mui/material';
import ReactMarkdown from 'react-markdown';
import logger from './../utils/logger.js';

const ChangelogDialog = ({ open, onClose }) => {
  const [changelog, setChangelog] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setLoading(true);
      fetch('/Changelog.md')
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to load changelog');
          }
          return response.text();
        })
        .then(text => {
          setChangelog(text);
          setLoading(false);
        })
        .catch(err => {
          logger.error('Error loading changelog:', err);
          setError('Could not load the changelog. Please try again later.');
          setLoading(false);
        });
    }
  }, [open]);

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="changelog-dialog-title"
    >
      <DialogTitle id="changelog-dialog-title">
        Changelog
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" variant="body1" sx={{ p: 2 }}>
            {error}
          </Typography>
        ) : (
          <Box sx={{ p: 1 }}>
            <ReactMarkdown>
              {changelog}
            </ReactMarkdown>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangelogDialog; 